/**
 * Enum for channel table fields
 * @readonly
 * @enum {Array}
 */
export const CHANNEL_TABLE_FIELDS = Object.freeze([
	{ key: 'name', label: 'Name' },
	{ key: 'slug', label: 'Slug' },
	{ key: 'type', label: 'Channel type' },
	{ key: 'updated_at', label: 'Date Modified' },
]);

/**
 * Enum for channel type
 * @readonly
 * @enum {Object}
 */
export const CHANNEL_TYPE = Object.freeze({
	ONLINE: 'online',
	OFFLINE: 'offline',
	EVENT: 'event',
});

/**
 * Enum for channel type
 * @readonly
 * @enum {Object}
 */
export const CHANNEL_TYPE_OPTIONS = Object.freeze([
	{
		name: 'Online',
		value: CHANNEL_TYPE.ONLINE,
	},
	{
		name: 'Offline',
		value: CHANNEL_TYPE.OFFLINE,
	},
	{
		name: 'Event',
		value: CHANNEL_TYPE.EVENT,
	},
]);